import { fetchAuth } from "../../../shared/api/ApiService";
import { ITeam, ITeamUpsertData } from "../model/types";

class TeamService {
    async list(workTgIds: number[] = []): Promise<ITeam[]> {
        const params = new URLSearchParams()
        workTgIds.forEach(id => params.append('work_tg_ids', String(id)))

        const query = params.toString()
        const res = await fetchAuth(
            process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/teams${query ? `?${query}` : ''}`
        )
        const data: {teams: ITeam[]} = await res.json()
        return data.teams
    }

    async get(teamId: string): Promise<ITeam> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/teams/${teamId}`)
        const data: {team: ITeam} = await res.json()
        return data.team
    }

    async create(data: ITeamUpsertData): Promise<ITeam> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + '/api/v1/teams', {
            method: 'POST',
            body: JSON.stringify(data),
        })
        const response: {team: ITeam} = await res.json()
        return response.team
    }

    async update(teamId: string, data: ITeamUpsertData): Promise<ITeam> {
        const res = await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/teams/${teamId}`, {
            method: 'POST',
            body: JSON.stringify({teamId, ...data}),
        })
        const response: {team: ITeam} = await res.json()
        return response.team
    }

    async delete(teamId: string, comment: string): Promise<void> {
        await fetchAuth(process.env.REACT_APP_SERVER_URL_ADMIN + `/api/v1/teams/${teamId}/delete`, {
            method: 'POST',
            body: JSON.stringify({teamId, comment}),
        })
    }
}

export const teamService = new TeamService()
